import {gql} from "@apollo/client";

export const ORDER_ITEMS = gql`
    mutation ($items: String!, $table: String!) {
        orderItems(items: $items, table: $table)
    }
`